<!--
  ~ Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
  ~
  ~ This SOURCE CODE FILE, which has been provided by Certusoft as part
  ~ of a Certusoft product for use ONLY by licensed users of the product,
  ~ includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
  ~
  ~ USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
  ~ OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
  ~ THE PRODUCT.
  -->

<div class="navbar navbar-default navbar-fixed-top">
    <div class="container-fluid">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
            <a class="navbar-brand logo" [routerLink]="['/app/3d']"></a>
        </div>

        <div id="collapseable" class="navbar-collapse collapse" aria-expanded="false">
            <ul class="nav navbar-nav" *ngIf="authenticated()">
                <!--        <li>-->
                <!--          <a [routerLink]="['/app/home']"-->
                <!--             class=""-->
                <!--             data-toggle="collapse"-->
                <!--             data-target=".navbar-collapse.in">-->
                <!--            <span>Home</span>-->
                <!--          </a>-->
                <!--        </li>-->

                <li>
                    <a
                        [routerLink]="['/app/3d']"
                        class="nav-threed"
                        data-toggle="collapse"
                        data-target=".navbar-collapse.in"
                    >
                        <span>Clik AI</span>
                    </a>
                </li>
            </ul>

            <app-menu></app-menu>
        </div>
    </div>
</div>

<div class="navbar-separator"></div>
